/**
 * Resolves the effective left-pinned column ids: a user override when provided, else the `meta.frozen` default.
 * Structural `alwaysPinned` columns (selection checkbox, inbox) are always forced to the front, and override ids
 * are filtered to columns that still exist.
 */
export function resolveLeftPinned(
  metaFrozenLeft: string[],
  alwaysPinnedLeft: string[],
  leafColumnIds: string[],
  override?: { left: string[] },
): string[] {
  if (!override) return metaFrozenLeft;
  const existing = new Set(leafColumnIds);
  const forced = alwaysPinnedLeft.filter((id) => existing.has(id));
  const forcedSet = new Set(forced);
  const userLeft = override.left.filter((id) => existing.has(id) && !forcedSet.has(id));
  return [...forced, ...userLeft];
}
